import { FuelRequestVoucherStateTypes, FuelRequestVoucherActionTypes } from "./FuelRequestVoucher.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FuelRequestVoucherStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FuelRequestVoucherReducer = (
  state: FuelRequestVoucherStateTypes = INITIAL_STATE,
  action: any
): FuelRequestVoucherStateTypes => {
  switch (action.type) {
    case FuelRequestVoucherActionTypes.FETCH_ALL_FUEL_REQUEST_VOUCHER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRequestVoucherActionTypes.FETCH_ALL_FUEL_REQUEST_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRequestVoucherActionTypes.FETCH_ALL_FUEL_REQUEST_VOUCHER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRequestVoucherActionTypes.FETCH_ALL_FUEL_REQUEST_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FuelRequestVoucherActionTypes.FETCH_ONE_FUEL_REQUEST_VOUCHER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRequestVoucherActionTypes.FETCH_ONE_FUEL_REQUEST_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRequestVoucherActionTypes.FETCH_ONE_FUEL_REQUEST_VOUCHER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRequestVoucherActionTypes.FETCH_ONE_FUEL_REQUEST_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FuelRequestVoucherReducer;
